
import { IFormSchema } from "@/@auditoinnit/auditoinnit/interfaces/IFormSchema";
import { TClassificationText } from "../interfaces/IObservation";

export const ClassificationTextMapper = {
    textToValue: (text: string, processingFormSchema: IFormSchema): TClassificationText => {
        const classificationProperty = processingFormSchema.schema.properties?.luokitteluteksti;
        const classificationUiProperty = processingFormSchema.uiSchema?.luokitteluteksti || {};
        const listSeparator = classificationUiProperty["ui:list_separator"] || "//"

        if (!classificationProperty) {
            return undefined
        }

        if (typeof classificationProperty !== "object") {
            throw Error("Invalid classification property")
        }

        if (classificationProperty.type === "string") {
            return text
        } else if (classificationProperty.type === "number") {
            return text ? Number(text) : undefined;
        } else if (classificationProperty.type === "array" && (classificationProperty.items as any).type === "string") {
            return (text || "").split(listSeparator)
        } else if (classificationProperty.type === "array" && (classificationProperty.items as any).type === "number") {
            return (text || "").split(listSeparator).map(Number);
        }

    },

    valueToText: (value: TClassificationText, processingFormSchema: IFormSchema): string => {
        const classificationUiProperty = processingFormSchema.uiSchema?.luokitteluteksti || {};
        const listSeparator = classificationUiProperty["ui:list_separator"] || "//"

        if (value && Array.isArray(value)) {
            return value.join(listSeparator)
        }

        return value ? String(value) : ""
    },
};


export default ClassificationTextMapper
